import { actaApi } from './actaApi';

export interface PublicationCreationPayload {
  entity_id: string;
  is_for_dom: boolean;
  is_for_dou: boolean;
  is_for_jgc: boolean;
  files: File[];
}

export interface JournalConfiguration {
  id: string;
  prefix: string;
  suffix: string;
  type: string; // Exemplo: "Poder Legislativo"
  dom_enabled: boolean;
  dou_enabled: boolean;
  jgc_enabled: boolean;
}

/**
 * Cria uma nova publicação chamando o endpoint POST /publications do Acta.
 * Aceita múltiplos arquivos PDF.
 */
export async function createPublication(payload: PublicationCreationPayload): Promise<any> {
  const formData = new FormData();

  formData.append('entity_id', payload.entity_id);
  formData.append('is_for_dom', String(payload.is_for_dom));
  formData.append('is_for_dou', String(payload.is_for_dou));
  formData.append('is_for_jgc', String(payload.is_for_jgc));

  for (const file of payload.files) {
    formData.append('files', file);
  }

  const response = await actaApi.post('/publications', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

/**
 * Busca a JournalConfiguration de determinada entidade (cfgId).
 */
export async function getJournalConfiguration(cfgId: string): Promise<JournalConfiguration> {
  const response = await actaApi.get<JournalConfiguration>(`/user-entity-journal-configurations/${cfgId}`);
  return response.data;
}

/**
 * Representa a resposta de listagem de publicações, com paginação.
 * Ajuste conforme seu backend.
 */
export interface PublicationListItem {
  id: string;
  title: string;
  status: string;
  published_at: string | null;
  summary: string;
}

export interface PublicationListResponse {
  items: PublicationListItem[];
  total: number;
  page: number;
  size: number;
}

/**
 * Retorna a lista de publicações, com paginação, filtrando por entity_id.
 * Ajuste a URL e parâmetros conforme sua rota real.
 * Exemplo: GET /publications?entity_id=xxx&page=1&limit=10
 */
export async function getPublications(
  entityId: string,
  page = 1,
  limit = 10
): Promise<PublicationListResponse> {
  const response = await actaApi.get<PublicationListResponse>(
    `/publications?entity_id=${entityId}&page=${page}&limit=${limit}`
  );
  return response.data;
}

/**
 * Busca uma publicação específica pelo `publicationId`, pertencente a `entityId`.
 * Exemplo de chamada GET: /publications/{publicationId}?entity_id={entityId}
 */
export async function getPublication(
  entityId: string,
  publicationId: string
): Promise<any> {
  const response = await actaApi.get<any>(
    `/publications/${publicationId}?entity_id=${entityId}`
  );
  return response.data;
}